import React from "react";
import Row from "antd/lib/row";
import Typography from "antd/lib/typography";
import Divider from "antd/lib/divider";

const { Paragraph } = Typography;

const Note: React.FC = () => (
    <>
        <Divider />
        <Row justify="center">
            <Paragraph>
                Note that our simulation assumes default producer &amp; broker
                configuration (for Kafka version &lt;2.8.0) which accepts new
                messages, even if a majority of brokers are down. See{" "}
                <a
                    href="https://blog.softwaremill.com/help-kafka-ate-my-data-ae2e5d3e6576"
                    target="_blank"
                    rel="noreferrer"
                >
                    this blog
                </a>{" "}
                for more details.
            </Paragraph>
        </Row>
    </>
);

export default Note;
